import { createSlice } from "@reduxjs/toolkit";

import { AuthInterface } from "./auth";

const initialState: AuthInterface = {
  jwtToken: localStorage.getItem("jwtToken"),
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setJwtTokenValue: (state, action: { payload: AuthInterface }) => {
      localStorage.setItem("jwtToken", action.payload.jwtToken!);
      state.jwtToken = action.payload.jwtToken;
    },
  },
});

export const { setJwtTokenValue } = authSlice.actions;
